import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m18.985 2.8 2.622 2.622v7.16l-9.476 9.475-9.781-9.78L11.826 2.8zm-.621 1.5h-5.916L4.47 12.276l7.66 7.66 7.976-7.976V6.044z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m8.172 12.084 8.178-1.64.295 1.47-8.178 1.64zm3.163-4.427a1.134 1.134 0 1 1 1.604 1.604 1.134 1.134 0 0 1-1.604-1.604m.537 7.086a1.134 1.134 0 1 1 1.604 1.604 1.134 1.134 0 0 1-1.604-1.604",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }